exports = module.exports = require("../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".video-player {\n  position: relative;\n  width: 100%;\n  height: 100%;\n  background: #000;\n}\n.video-player-wrapper {\n  position: relative;\n  width: 100%;\n  height: 100%;\n}\n.video-player .blur-image {\n  position: absolute;\n  left: 0;\n  top: 0;\n  width: 100%;\n  height: 100%!important;\n}\n", ""]);

